<template>
  <div id="events" class="module">
    <div class="flexbox flexbox__v-center">
      <h1>Event Tickets</h1>

      <el-button
        :type="primary"
        :class="{ active: current }"
        size="small"
        @click="updateCurrent(true)"
        >Current</el-button
      >

      <el-button
        :type="primary"
        :class="{ active: !current }"
        size="small"
        @click="updateCurrent(false)"
        >Past</el-button
      >

      <!-- <el-col class="page-tracker">{{ currentPage }}/{{ $attrs.table.length }}</el-col> -->

      <!-- <el-pagination background layout="prev, next" @current-change="handleCurrentChange"></el-pagination> -->
    </div>

    <div class="cards">
      <el-card
        v-for="(event, index) in $attrs.table"
        v-show="isCurrent(event.date) == current"
        :key="increment(index)"
        class="box-card"
      >
        <event
          :name="event.name"
          :date="event.date"
          :complimentaryTickets="event.complimentaryTickets"
          :ticketsPurchased="event.ticketsPurchased"
        ></event>
      </el-card>
    </div>
  </div>
</template>

<script>
import Event from "@/components/Event";

export default {
  name: "Events",
  components: {
    Event
  },
  methods: {
    increment(int) {
      return int + 1;
    },
    updateCurrent(val) {
      this.current = val;
    },
    isCurrent(date) {
      var today = new Date();
      var eventDate = new Date(date);
      return today.getTime() < eventDate.getTime();
    }
  },
  data() {
    return {
      // currentPage: 1
      current: true
    };
  }
};
</script>

<style lang="scss" scoped>
.active {
  background-image: linear-gradient(
    -90deg,
    #00b6de 0%,
    rgba(0, 214, 132, 0.89) 100%
  );
  color: #ffffff;
}

p {
  font-size: 14px;
  color: #8a8a8a;
  letter-spacing: 0;
  line-height: 20px;
}

.box-card {
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.el-button {
  border: 0px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.23);

  &:first-of-type {
    margin-left: auto;
  }
}

/* .page-tracker {
	font-weight: 700;
	font-size: 11px;
	color: rgba(144, 144, 144, 0.59);
	letter-spacing: 2px;
	text-align: right;
	line-height: 20px;
} */
</style>
